import { TYPE } from "@gaoya/shared";
import { C, capsuleBox, clipName, drawArt, drawCircleAvatar, drawPanel, fillRound, roundPath, art } from "../theme.js";
import type { UiState } from "../../game/state.js";
import { layoutLogin } from "../../ui/hall.js";

export function drawLogin(ctx: CanvasRenderingContext2D, ui: UiState, w: number, h: number): void {
  const cap = capsuleBox(ui, w);
  const btns = layoutLogin(w, h, ui);
  const firstBtnY = Math.min(...btns.map((b) => b.y));
  const cardH = 132;
  const avail = firstBtnY - cap.bottom;
  const L = Math.max(104, Math.min(160, avail - cardH - 120));
  const block = L + 14 + cardH + 40;
  const heroTop = cap.bottom + Math.max(12, (avail - block) * 0.42);
  const cx = w / 2;
  const cardY = heroTop + L + 14;

  // 标题区：书生 · 招牌 · 侠客（立于入座卡之后，腰线被卡片遮住）
  const charH = L * 0.92;
  const charW = Math.min(charH, (w - L) / 2 + 10);
  const charBottom = cardY + 22;
  drawArt(ctx, "char-scholar-cut", cx - L / 2 - charW + 16, charBottom - charH, charW, charH);
  drawArt(ctx, "char-xia-cut", cx + L / 2 - 16, charBottom - charH, charW, charH);
  const logo = art("icon");
  const lx = cx - L / 2;
  fillRound(ctx, lx, heroTop + 4, L, L, L * 0.2, "rgba(140,38,22,0.35)");
  if (logo) {
    ctx.save();
    roundPath(ctx, lx, heroTop, L, L, L * 0.2);
    ctx.clip();
    ctx.drawImage(logo, lx, heroTop, L, L);
    ctx.restore();
  } else {
    fillRound(ctx, lx, heroTop, L, L, L * 0.2, C.seal);
    ctx.fillStyle = "#FFF7EE";
    ctx.font = `700 ${Math.round(L * 0.2)}px ${TYPE.serif}`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("接词大乱斗", cx, heroTop + L / 2);
  }
  ctx.strokeStyle = "rgba(255,247,238,0.6)";
  ctx.lineWidth = 2;
  roundPath(ctx, lx + 1, heroTop + 1, L - 2, L - 2, L * 0.2);
  ctx.stroke();

  // 入座卡
  const cardW = Math.min(320, w - 48);
  const cardX = (w - cardW) / 2;
  drawPanel(ctx, cardX, cardY, cardW, cardH, 16);
  const avR = 26;
  drawCircleAvatar(
    ctx,
    ui.avatarImg,
    cardX + 24 + avR,
    cardY + 46,
    avR,
    ui.wxProfileReady ? ui.nickname : ui.useWxProfile ? "微" : ui.nickname,
  );
  const tx = cardX + 24 + avR * 2 + 16;
  ctx.textAlign = "left";
  ctx.fillStyle = C.ink3;
  ctx.font = `12px ${TYPE.sans}`;
  ctx.fillText("今日入座", tx, cardY + 34);
  ctx.fillStyle = C.ink;
  ctx.font = `700 19px ${TYPE.serif}`;
  ctx.fillText(
    clipName(ctx, ui.wxProfileReady || !ui.useWxProfile ? ui.nickname : "微信昵称", cardX + cardW - tx - 16),
    tx,
    cardY + 56,
  );
  fillRound(ctx, cardX + 16, cardY + 88, cardW - 32, 28, 8, C.cardSoft);
  ctx.fillStyle = C.ink2;
  ctx.font = `12px ${TYPE.sans}`;
  ctx.textAlign = "center";
  const note = ui.useWxProfile
    ? ui.privacyAgreed
      ? "使用微信头像与昵称入座"
      : "需先同意隐私政策，再授权头像昵称"
    : "雅号随机生成 · 可点下方换一个";
  ctx.fillText(clipName(ctx, note, cardW - 48), cx, cardY + 102);

  const tagY = cardY + cardH + 26;
  ctx.fillStyle = C.ink2;
  ctx.font = `500 13px ${TYPE.sans}`;
  ctx.textAlign = "center";
  const tag = "成语接龙 · 实时对决";
  ctx.fillText(tag, cx, tagY);
  const tw = ctx.measureText(tag).width;
  ctx.fillStyle = C.lineStrong;
  ctx.fillRect(cx - tw / 2 - 34, tagY, 22, 1);
  ctx.fillRect(cx + tw / 2 + 12, tagY, 22, 1);
}
